import IconDelete from '../../../../../../components/icons/icon-delete/icon-delete';
import { ButtonIcon } from '../../../../../../components/inputs/button-icon/button-icon';
import ApiKeyEditorStore from '../../../stores/api-key-editor-store';

interface DeleteApiKeyButtonProps {
    apiKey: ApiKeyEditorStore;
    isDisabled: boolean;
    onClick: (apiKey: ApiKeyEditorStore) => void;
}

const IconDeleteAccent = () => ( <IconDelete color="var(--color-accent-1)" />);

const DeleteApiKeyButton: React.FC<DeleteApiKeyButtonProps> = ({ apiKey, isDisabled, onClick }) => {
    return (
        <ButtonIcon Component={IconDeleteAccent} onClick={() => onClick(apiKey)} disabled={isDisabled} />
    );
};

export default DeleteApiKeyButton;
